"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChunk = void 0;
exports.getChunk = (line) => {
    let out = '';
    let parenCount = 0;
    for (const char of line) {
        if (char === ';' || char === '\n') {
            break;
        }
        out += char;
        if (char === ')') {
            parenCount -= 1;
            if (parenCount <= 0) {
                break;
            }
        }
        if (char === '(') {
            parenCount += 1;
        }
    }
    return out;
};

//# sourceMappingURL=utils.js.map
